import React, { ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import MoreIcon from '../../../../BaseComponents/Icons/MoreIcon'
import { TestID } from '../../../../utils/PropTypesDefinitions'

type Props = { onMorePress?: () => void } & TestID

const MoreButton = ({ onMorePress, testID }: Props): ReactElement | null => {
    if (onMorePress) {
        return (
            <Grid
                marginRight={3}
                marginLeft={[3, 3, 16]}
                width="18px"
                testID={testID}
                noExpand
                center
            >
                <Touchable onPress={onMorePress}>
                    <Grid center>
                        <MoreIcon />
                    </Grid>
                </Touchable>
            </Grid>
        )
    }
    return null
}

export default MoreButton
